import { render } from "./site-inspections.vue?vue&type=template&id=56fadc61&scoped=true"
import script from "./site-inspections.vue?vue&type=script&lang=js"
export * from "./site-inspections.vue?vue&type=script&lang=js"

import "./site-inspections.vue?vue&type=style&index=0&id=56fadc61&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fadc61"]])

export default __exports__